import React, {Component} from 'react';
import Main from '../Main';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {setLoadingPatchUserData, patchUserData, patchUserDataSuccess, patchUserDataError,
    setLoadingGetUser, getUser, getUserSuccess, getUserError} from '../../actions/UserActions';
import {setLoadingGetRoles, getRoles, getRolesSuccess, getRolesError} from '../../actions/RoleActions';
import { TRANSLATE_UPLOAD_PHOTO, TRANSLATE_IMAGE_USER, TRANSLATE_EDIT_USER, TRANSLATE_FIRST_NAME, TRANSLATE_LAST_NAME, 
    TRANSLATE_EMAIL, TRANSLATE_PHONE, TRANSLATE_ROLE, TRANSLATE_PHOTO, TRANSLATE_SAVE, TRANSLATE_CANCEL } from '../../translates/Translates';
import { path_users } from '../../routes/Pathnames';
import {Link} from 'react-router-dom';

class EditUser extends Component{
    constructor(props){
        super(props);

        this.state = {
            user: {},
            roles: []
        }
    }

    componentDidMount = () => {
        this.props.setLoadingGetRoles();
        this.props.getRoles().then((response) => {
            this.setState({roles: response.payload.data});
            this.props.getRolesSuccess();
            this.props.setLoadingGetUser();
            this.props.getUser(this.props.match.params.user_id).then((response_data) => {
                this.setState((prevState) =>{
                    let user = response_data.payload.data;
                    let file = new File([], user.source);
                    if(file.name !== ''){
                        user.photo = file;
                    }else{
                        user.photo = null;
                    }
                    return {
                        ...prevState,
                        user
                    }
                });
                this.props.getUserSuccess();
            }).catch(() => {
                this.props.getUserError();
            })
        }).catch(() => {
            this.props.getRolesError();
        })
    }

    onChangeField = (event) => {
        const value = event.target.value;
        const name = event.target.name;
        this.setState((prevState) => {
            let user = {...prevState.user};
            user[name] = value;
            return {
                ...prevState,
                user
            }
        })
    }

    deleteForm = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                user: {
                    name: '',
                    surname: '',
                    email: '',
                    phone: '',
                    photo: null,
                    source: '',
                    role: 1
                },
            }
        })
    }

    handleFileChange = (event) => {
        if(event.target.files.length > 0){
            let photo = event.target.files[0];
            let reader = new FileReader();
            reader.onload = () => {
                this.setState((prevState) => {
                    let user = {...prevState.user};
                    user.photo = photo;
                    user.source = reader.result;
                    return {
                        ...prevState,
                        user
                    } 
                })
            };
            reader.readAsDataURL(photo);
        }
    }

    submitForm = (userData) => {
        this.props.setLoadingPatchUserData();
        this.props.patchUserData(userData).then((response) => {
            this.props.patchUserDataSuccess();
        }).catch(() => {
            this.props.patchUserDataError();
        })
    }

    render(){
        return(
            <div>
                <Main/>
                <div className="page-wrapper">
                    <div className="container-fluid">
                        <br />
                        <div className="row page-tier3">
                            <div className="col s12">
                                <div className="card card-outline-info">
                                    <div className="card-header">
                                        <h4 className="mb-0 text-white">{TRANSLATE_EDIT_USER}</h4>
                                    </div>
                                    <div className="card-body">
                                        {this.props.loadingGetUser || this.props.loadingGetRoles ? (
                                            <div className="preloader">
                                                <svg className="circular" viewBox="25 25 50 50">
                                                    <circle className="path" cx="50" cy="50" r="20" fill="none" />
                                                </svg>
                                            </div>
                                        ) : (
                                        <form method="post">
                                            <div className="form-body">
                                                <div className="row pt-3">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">{TRANSLATE_FIRST_NAME}</label>
                                                            <input type="text" id="name" name="name" className="form-control" value={this.state.user.name} onChange={this.onChangeField} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">{TRANSLATE_LAST_NAME}</label>
                                                            <input type="text" id="surname" name="surname" className="form-control" value={this.state.user.surname} onChange={this.onChangeField} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">{TRANSLATE_EMAIL}</label>
                                                            <input type="email" id="email" name="email" className="form-control" value={this.state.user.email} onChange={this.onChangeField} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">{TRANSLATE_PHONE}</label>
                                                            <input type="text" id="phone" name="phone" className="form-control" value={this.state.user.phone} onChange={this.onChangeField} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">{TRANSLATE_ROLE}</label>
                                                            <select className="form-control custom-select" name="role" value={this.state.user.role} onChange={this.onChangeField}>
                                                                {this.state.roles.map((role) => {
                                                                    return(
                                                                        <option value={role.id} key={role.id}>{role.name}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                            <small className="form-control-feedback"></small>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6"></div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">{TRANSLATE_PHOTO}</label>
                                                            <div className="mb-2">
                                                            {
                                                                this.state.user.source ? (
                                                                    <div className="create-user-photo">
                                                                        <img src={this.state.user.source} className="create-user-photo__img mb-3" alt={TRANSLATE_IMAGE_USER} />
                                                                    </div>
                                                                ) : ''
                                                            }
                                                                <label htmlFor="photo" className="create-user__label-upload btn btn-success mb-3">
                                                                    <span className="text">{TRANSLATE_UPLOAD_PHOTO}</span>
                                                                    <input type="file" id="photo" onChange={this.handleFileChange}/>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6"></div>
                                                </div>
                                            </div>
                                            <div className="form-actions">
                                                <button type="button" className="btn btn-success mr-3" onClick={() => this.submitForm(this.state.user)}> 
                                                    <i className="fa fa-check"></i>&nbsp;{TRANSLATE_SAVE}
                                                </button>
                                                <Link to={path_users} className="btn btn-inverse" >{TRANSLATE_CANCEL}</Link>
                                            </div>
                                        </form>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        loadingGetUser: state.userReducer.loadingGetUser,
        loadingGetRoles: state.roleReducer.loadingGetRoles
    }
} 

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setLoadingGetRoles,
        getRoles,
        getRolesSuccess,
        getRolesError,
        setLoadingGetUser, 
        getUser,
        getUserSuccess,
        getUserError,
        setLoadingPatchUserData,
        patchUserData,
        patchUserDataSuccess,
        patchUserDataError
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditUser);
